import {
    CLEAR,
    LOGIN_REQUEST,
    LOGIN_SUCCESSFUL,
    LOGIN_FAILED,
    LOGIN_SET_AUTHENTICATE,
    LOGIN_OPEN_PINCODE_MODAL,
    LOGIN_SAVE_2FA_AUTH_INFO,
    PASSWORD_TOO_WEAK,
    LOGIN_SET_AUTH_METHODS,
    BRIDGE_SSO_SETTLED,
} from './types';
import { detectBridgeEntry, getEntryLocation } from '../../auth/ssoBridge';

const initState = {
    fetching: false,
    isAuthenticate: false,
    isPinCodeModalOpen: false,
    twoFAuthInfo: {
        sessionId: '',
        url: '',
    },
    isPasswordWeak: false,
    authMethods: [],
    // True only for a bridged arrival, and only until the bridge has taken a
    // decision. Seeded synchronously from the URL the browser arrived on, so
    // the very first render already knows to hold rather than show a login
    // screen the silent login is about to navigate away from.
    isBridgeSsoPending: detectBridgeEntry(getEntryLocation()) !== null,
};

const reducer = (state = initState, action) => {
    switch (action.type) {
        case CLEAR:
            return {
                ...initState,
                // A logout must not re-arm the hold: the bridge decided long
                // ago, and re-seeding it from the entry URL would blank the app.
                isBridgeSsoPending: false,
            };

        case BRIDGE_SSO_SETTLED:
            return {
                ...state,
                isBridgeSsoPending: false,
            };

        case LOGIN_REQUEST:
            return {
                ...state,
                fetching: true,
            };

        case LOGIN_SUCCESSFUL:
            return {
                ...state,
                fetching: false,
                isAuthenticate: true,
            };

        case LOGIN_SET_AUTHENTICATE:
            return {
                ...state,
                fetching: false,
                isAuthenticate: action.payload,
            };

        case LOGIN_FAILED:
            return {
                ...state,
                fetching: false,
                isAuthenticate: false,
            };

        case LOGIN_OPEN_PINCODE_MODAL:
            return {
                ...state,
                isPinCodeModalOpen: action.payload,
            };

        case LOGIN_SAVE_2FA_AUTH_INFO:
            return {
                ...state,
                twoFAuthInfo: {
                    sessionId: action.payload.sessionId,
                    url: action.payload.url,
                    pinCodeFormat: action.payload.pinCodeFormat,
                },
            };

        case PASSWORD_TOO_WEAK:
            return {
                ...state,
                isPasswordWeak: action.payload,
            };

        case LOGIN_SET_AUTH_METHODS:
            return {
                ...state,
                authMethods: action.payload,
            };

        default:
            return state;
    }
};

export default reducer;
